/**
 * 计算累加
 * @returns {Decimal}
 */
export function computeSum() {
  let sum = 0;
  for (let i = 0; i < arguments.length; i++) {
    arguments[i] = Number(arguments[i]);
    if (!isNaN(arguments[i])) {
      sum += arguments[i];
    }
  }
  return Number(sum.toFixed(2));
}

/**
 * 两数相加
 */
export function add(a = 0, b = 0, scale = 2) {
  if (!a) {
    a = 0
  }
  if (!b) {
    b = 0
  }
  return Number((Number(a) + Number(b)).toFixed(scale))
}

/**
 * 两数相减
 */
export function sub(a = 0, b = 0, scale = 2) {
  return Number((Number(a) - Number(b)).toFixed(scale))
}

export function mul(a = 0, b = 0, scale = 2) {
  return Number((Number(a) * Number(b)).toFixed(scale))
}

export function div(a = 0, b = 1, scale = 2) {
  if (!a) {
    a = 0
  }
  if (!b || Number(b) === 0) {
    return 0
  }
  return Number((Number(a) / Number(b)).toFixed(scale))
}

/**
 *
 * @param a
 * @param b
 * @param diff 容差值
 * @returns {boolean}
 */
export function equals(a, b, diff = 0) {
  const df = sub(a, b)
  if (diff === 0) {
    return a === b
  }
  diff = Math.abs(diff)
  return a === b || (df <= diff && df >= -diff)
}

const NumberUtils = {
  computeSum,
  add,
  sub,
  mul,
  div,
  equals
}
export default NumberUtils

